import { CheckoutState } from '../../state';

export const getCanMakePaymentsWithGooglePay = (state: CheckoutState) =>
    !!state.googlePay.canMakePaymentsWithGooglePay;

export const getGooglePayInstance = (state: CheckoutState) =>
    state.googlePay.googlePayInstance;

export const getGooglePayPaymentRequest = (state: CheckoutState) =>
    state.googlePay.googlePayPaymentRequest;

export const hasErrorInGooglePay = (state: CheckoutState) =>
    state.googlePay.hasError;

export const getGooglePayScriptStatus = (state: CheckoutState) =>
    state.googlePay.googlePayScriptStatus;

export const isLoadingGooglePay = (state: CheckoutState) =>
    state.googlePay.isLoadingGooglePay;
